/** Follow the OS light/dark preference using Bootstrap 5.3 color modes. */
export function initTheme(): void {
	const mq = window.matchMedia("(prefers-color-scheme: dark)");
	const apply = () => {
		document.documentElement.setAttribute("data-bs-theme", mq.matches ? "dark" : "light");
	};
	apply();
	mq.addEventListener("change", apply);
}
